import { GET_DESTINOS_ERROR, GET_DESTINOS_LOADING, GET_DESTINOS_SUCCESS } from "./destino_types"
import { CREATE_DESTINOS_ERROR, CREATE_DESTINOS_LOADING, CREATE_DESTINOS_SUCCESS } from "./destino_types"
import { UPDATE_DESTINOS_ERROR, UPDATE_DESTINOS_LOADING, UPDATE_DESTINOS_SUCCESS } from "./destino_types"
import { DELETE_DESTINOS_ERROR, DELETE_DESTINOS_LOADING, DELETE_DESTINOS_SUCCESS } from "./destino_types"


let initialState = {
    loading: false,
    error: false,
    data: []
}

export const destinoReducer = (state=initialState, action)=>{
    const {type, payload} = action
    switch(type){
        case GET_DESTINOS_LOADING: {
            return {
                ...state, loading: true
            } 
        }
        case GET_DESTINOS_SUCCESS: {
            return {
                ...state, loading: false, error: false, datadestino: payload
            }
        }
        case GET_DESTINOS_ERROR: {
            return {
                ...state, loading: false, error: true
            }
        }
        case CREATE_DESTINOS_LOADING: {
            return {
                ...state, loading: true
            } 
        }
        case CREATE_DESTINOS_SUCCESS: {
            return {
                ...state, loading: false, error: false, data: payload
            }
        }
        case CREATE_DESTINOS_ERROR: {
            return {
                ...state, loading: false, error: true
            }
        }
        case UPDATE_DESTINOS_LOADING: {
            return {
                ...state, loading: true
            } 
        }
        case UPDATE_DESTINOS_SUCCESS: {
            return {
                ...state, loading: false, error: false, data: payload
            }
        }
        case UPDATE_DESTINOS_ERROR: {
            return {
                ...state, loading: false, error: true
            }
        }
        case DELETE_DESTINOS_LOADING: {
            return {
                ...state, loading: true
            } 
        }
        case DELETE_DESTINOS_SUCCESS: {
            return {
                ...state, loading: false, error: false, data: payload
            }
        }
        case DELETE_DESTINOS_ERROR: {
            return {
                ...state, loading: false, error: true
            }
        }
        default: {
            return state
        }
    }
}